<template lang="pug">
    section.stock-step
        el-alert(
            v-if="!options.stock.items.length"
            type="warning"
            :title="$t('This shop has no stock configured.')"
            effect="dark"
            :closable="false"
        )
        transition(name="slide-decent-vertical" mode="out-in")
            .stock-fields(v-if="form.manage_stock")
                el-form-item(:label="$t('Stock')" prop="articleStock.id")
                    el-input.loading(v-if="form.articleStock && options.stock.loading" :value="form.articleStock.name" :disabled="true")
                    el-select.is-full-width(
                        v-else
                        placeholder="" v-model="form.articleStock" valueKey="id"
                        :class="{ 'loading': options.stock.loading }"
                        :disabled="options.stock.items.length <= 1"
                    )
                        el-option(v-for="item in options.stock.items" :key="item.id" :label="item.name" :value="item")
                el-form-item(:label="$t('Out of stock threshold')" prop="out_of_stock_threshold")
                    el-input-number(v-model="form.out_of_stock_threshold" :step="1" step-strictly :precision="0" :disabled="true")
                el-form-item(:label="$t('Stock quantity for every article')" prop="articleQty")
                    el-input-number(v-model="form.articleQty" :step="1" step-strictly :precision="0")
            el-alert(
                v-else
                type="info"
                :title="$t('As long as the \"Manage stock\" setting is disabled, this product will remain salable.')"
                :closable="false"
            )
        el-form-item.no-margin
           el-switch(
               :active-text="$t('Manage stock')"
               :disabled="!options.stock.items.length"
               v-model="form.manage_stock"
           )
</template>

<i18n>
{
    "de": {
        "Stock": "Lager",
        "Manage stock": "Bestand verwalten",
        "Out of stock threshold": "Ausverkaufsschwelle",
        "Stock quantity for every article": "Lagermenge je Artikel",
        "This shop has no stock configured.": "Dieser Shop hat keine Lagerkonfiguration.",
        "As long as the \"Manage stock\" setting is disabled, this product will remain salable.": "Solange die Einstellung \"Bestand verwalten\" deaktiviert ist, bleibt dieses Produkt verkaufbar."
    }
}
</i18n>

<script>
import pinia from '@/pinia';
import { useShopProductStore } from '@/stores';

export default {
    name: 'StockStep',
    props: {
        form: {
            type: Object,
            required: true,
        },
        rules: {
            type: Object,
            required: true,
        },
    },
    computed: {
        shopProductStore() {
            return useShopProductStore(pinia);
        },
        options() {
            return this.shopProductStore.options;
        },
    },
    mounted() {
        if (!this.form.articleStock && this.options.stock.items.length) {
            this.form.articleStock = this.options.stock.items[0];
        } else if (!this.options.stock.items.length) {
            this.form.manage_stock = false;
        }
    },
};
</script>

<style lang="sass" scoped>
.el-alert
    margin-bottom: 1rem
</style>
